<template>
  <a-config-provider :theme="themeConfig">
    <body>
      <slot></slot>
    </body>
  </a-config-provider>
</template>

<script setup>
import { theme } from 'ant-design-vue';

const themeConfig = {
  token: {
    algorithm: true,
    colorPrimary: 'var(--primary-color)',
    colorPrimaryHover: 'var(--secondary-color)',
    colorBorder: 'var(--white-opacity-8)',
  },
  primaryColor: 'var(--primary-color)',
  components: {
    Message: {
      algorithm: true,
    },
    Button: {
      algorithm: true,
      colorPrimary: 'var(--primary-color)',
      colorPrimaryHover: 'var(--secondary-color)',
      colorBorder: 'var(--white-opacity-8)',
    },
    Tabs: {
      algorithm: true,
      colorPrimary: 'var(--primary-color)',
    },
    Radio: {
      algorithm: true,
      colorPrimary: 'var(--primary-color)',
    },
    Input: {
      algorithm: true,
      colorPrimary: 'var(--primary-color)',
      colorPrimaryHover: 'var(--secondary-color)',
      colorBorder: 'var(--white-opacity-8)',
    },
    Select: {
      algorithm: true,
      colorPrimary: 'var(--primary-color)',
      colorPrimaryHover: 'var(--secondary-color)',
      colorBorder: 'var(--white-opacity-8)',
    },
    Table: {
      algorithm: true,
      headerColor: '#888888',
      headerBg: 'var(--white-opacity-8)',
      headerSplitColor: 'transparent',
      colorSplit: 'transparent',
      controlItemBgHover: 'transparent',
      headerFilterHoverBg: 'transparent',
      rowHoverBg: 'var(--primary-color)',
      rowSelectedHoverBg: 'transparent',
      rowSelectedBg: 'transparent',
      headerSortHoverBg: 'transparent',
      cellPaddingBlock: '0.5rem',
      borderRadius: '0.5rem',
    },
    Checkbox: {
      algorithm: true,
      colorPrimary: 'var(--primary-color)',
      borderRadiusSM: 2,
    },
  },
  algorithm: theme.defaultAlgorithm,
};
</script>
